import { Link } from "react-router-dom";
import React from 'react'
import CountUp from 'react-countup'; 
import heroImg from '../../assets/img/home3/hero-big-img.jpg';
import img1 from '../../assets/img/home3/3d-element.png';
import img2 from '../../assets/img/home3/element-wave.png';
import img3 from '../../assets/img/home3/card.png';
import img4 from '../../assets/img/home3/play-icon.png';

const HeroThree = () => {
    return (
        <section className="hero-wrapper hero-3">
            <div className="welcome-slide">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 pe-lg-0 d-flex justify-content-center align-center">
                            <div className="hero-content text-center text-md-start">
                                <h1>Raw Cotton </h1>
                                 
                                <p>Cotton is a natural fiber harvested from the cotton plant, serving as the foundation of the global textile industry. Grown in tropical and subtropical regions, cotton thrives in areas with a frost-free growing period of at least 150 days per year. </p>
                                
                             
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="hero-image">
                                <div className="big-img">
                                    <img src={heroImg} alt="" />
                                    <div className="element">
                                        <img src={img1} alt="" />
                                        <img src={img2} alt="" />
                                    </div>
                                </div>
                                <div className="card-img">
                                    <img src={img3} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="play-icon d-none d-lg-block">
                    <img src={img4} alt="" />
                </div>
            </div>
        </section>
    )
}

export default HeroThree;